import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataService } from '../../../services/data/data.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import {
  BANK_ACCOUNT_LABEL,
  CREDIT_CARD_LABEL,
  MONTHS,
  PAYMENT_FLOW_PAST_DUE,
  PAYMENT_TYPE_BANK_ACCOUNT,
  PAYMENT_TYPE_CREDIT_CARD,
} from '../../../utils/constants';
import { IBankAccountFormGroup, IBillingInformationFormGroup, ICreditCardFormGroup, IPaymentFlow, IPaymentType } from '../../../interfaces/IPayments';
import { UtilitiesService } from '../../../services/utilities/utilities.service';
import { PaymentService } from '../../../services/payment/payment.service';
import { LOCK_SYMBOL_CODE, SECURE_ENCRYPTION_MSG } from '../update-billing/update-billing.constants';

@Component({
  selector: 'app-add-payment',
  templateUrl: './add-payment.component.html',
  styleUrl: './add-payment.component.scss'
})

export class AddPaymentComponent implements OnInit, OnDestroy {
  creditCardForm!: FormGroup<ICreditCardFormGroup>;
  billingInformationForm!: FormGroup<IBillingInformationFormGroup>;
  bankAccountForm!: FormGroup<IBankAccountFormGroup>;
  
  @Input() paymentTypeSelected!: IPaymentType|null;
  cleaner$ = new Subject<void>();
  isSubmitting = false;
  card_payment = PAYMENT_TYPE_CREDIT_CARD;
  bank_acc_payment = PAYMENT_TYPE_BANK_ACCOUNT;
  billingDay: string = '';
  chargeAmount: string = '';
  billingMonth: string = '';
  paymentInitiatedFlow!: IPaymentFlow | null;
  pastDueFlow = PAYMENT_FLOW_PAST_DUE;
  creditCardLabel = CREDIT_CARD_LABEL;
  bankAccountLabel = BANK_ACCOUNT_LABEL;
  billingType!: string;
  secureEncryptionMessage= SECURE_ENCRYPTION_MSG;
  lockSymbol: string = LOCK_SYMBOL_CODE;

  constructor(private data: DataService, private util: UtilitiesService, private paymentService: PaymentService) {}

  ngOnInit(): void {
    this.creditCardForm = this.paymentService.ccForm;
    this.bankAccountForm = this.paymentService.bankAccForm;
    this.billingInformationForm = this.paymentService.billingInfoForm;
    this.initBillingAddress();
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }

  initBillingAddress(): void {
    this.data.contractData$.pipe(takeUntil(this.cleaner$)).subscribe({
      next: (contractData) => {
        if (!contractData) { return; }

        this.billingInformationForm.patchValue({
          address: contractData.billingAddress.addressLine1,
          address2: contractData.billingAddress.addressLine2,
          city: contractData.billingAddress.city,
          state: contractData.billingAddress.state,
          zipCode: contractData.billingAddress.zip,
        });

        const chargeDate = contractData.balanceInfo.chargeDateFormatUS;
        this.billingDay = this.util.getBillingDayFormatForUI(chargeDate?.substring(3, 5)||'');
        this.chargeAmount = contractData.baseContract.chrgAmt;
        const month: string = chargeDate?.substring(0, 2) || '';
        const monthIndex = Number(month) - 1;
        this.billingMonth = month && monthIndex >= 0 && monthIndex < MONTHS.length ? MONTHS[monthIndex] : '';
        this.billingType = contractData.balanceInfo.paymentScheduleTypeCode;
      },
    });

    this.data.paymentInitiation$.pipe(takeUntil(this.cleaner$)).subscribe({
      next: (paymentInitiation) => {
        if (!paymentInitiation) { return; }
        this.paymentInitiatedFlow = paymentInitiation;
      },
    });
  }
}
